var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8283 7.08572C14.4351 6.6925 8.20255.459938 7.91428.171661c-.22877-.2288815-.59979-.2288815-.82856 0C6.77044.486946.558357 6.69891.171661 7.08572c-.2288815.22877-.2288815.59979 0 .82867.228768.22877.599785.22877.828549 0l.1521-.15209v6.6518c0 .3236.26241.5859.58593.5859H13.2618c.3235 0 .5859-.2623.5859-.5859V7.7623l.152.15209c.2289.22877.5999.22877.8286 0 .2289-.22888.2289-.5999 0-.82867ZM9.21879 13.8281H5.78133v-3.4374h3.43746v3.4374Zm3.45701 0h-2.2851V9.80473c0-.32364-.2623-.58594-.58597-.58594H5.19539c-.32364 0-.58594.2623-.58594.58594v4.02337H2.3243V6.59042L7.5 1.4146l5.1758 5.17582v7.23768Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.915ef6da.svg";
export { ForwardRef as ReactComponent };